namespace Matrix.Administration {
    export interface PermissionSetRow {
        PermissionSetCode?: string;
        Name?: string;
        DefaultPermissions?: string[];
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        GrantedPermissions?: string[];
        AssignedToRoles?: string[];
    }

    export namespace PermissionSetRow {
        export const idProperty = 'PermissionSetCode';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Administration.PermissionSet';
        export const lookupKey = 'Administration.PermissionSet';

        export function getLookup(): Q.Lookup<PermissionSetRow> {
            return Q.getLookup<PermissionSetRow>('Administration.PermissionSet');
        }
        export const deletePermission = 'Administration:Security';
        export const insertPermission = 'Administration:Security';
        export const readPermission = 'Administration:Security';
        export const updatePermission = 'Administration:Security';

        export declare const enum Fields {
            PermissionSetCode = "PermissionSetCode",
            Name = "Name",
            DefaultPermissions = "DefaultPermissions",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            GrantedPermissions = "GrantedPermissions",
            AssignedToRoles = "AssignedToRoles"
        }
    }
}
